import { Product_ } from 'src/api/db/apiProductsClosed'
import { TableProduct } from './types'

export const transformProductData = (
  products: Product_[] | undefined
): TableProduct[] => {
  if (!products) return []

  return products.map((product) => ({
    id: product.id,
    article_number: product.article_number ?? '',
    item_name: product.item_name ?? '',
    item_name_translations: product.item_name_translations ?? null,
    item_description: product.item_description ?? '',
    created_at: new Date(product.created_at).toISOString(),
    source: product.source ?? '',
    image_url:
      product.product_variant?.[0]?.product_variant_color?.[0]
        ?.product_image?.[0]?.image_url ?? undefined,
    product_variant: product.product_variant?.map((variant) => variant) || [],
    packaging_cost: product.packaging_cost,
    print_codes:
      product.print_codes === null || product.print_codes === undefined
        ? null
        : typeof product.print_codes === 'string'
        ? product.print_codes
        : JSON.stringify(product.print_codes),
    klayder_recommends: product.klayder_recommends,
    category_product: (product as any).category_product || [],
    price: product.price,
  }))
}
